<template>
  <div class="appointment-setting">
    <Navbar title="预约设置"></Navbar>
    <!-- 标签栏 -->
    <div class="tabbar">
      <van-tabs
        type="card"
        color="#007aff"
        title-inactive-color="black"
        v-model="appointmentForm.category"
      >
        <van-tab title="洗车清洁" name="1">
          <!-- 预约时间 -->
          <div class="block">
            <div class="title">预约时间设置</div>
            <div class="content">
              <van-row class="appointment-item">
                <van-col span="11">时间段</van-col>
                <van-col span="11">可预约人数</van-col>
                <van-col span="2"></van-col>
              </van-row>
              <div v-for="(item, index) in appointmentList" :key="index">
                <van-row class="appointment-item" v-if="item.category == 1">
                  <van-col span="11" @click="handleEditTime(index)">
                    {{ item.startTime + "-" + item.endTime }}
                  </van-col>
                  <van-col span="11" @click="handleEditTime(index)">
                    {{ item.appointmentCount }}
                  </van-col>
                  <van-col span="2">
                    <van-icon
                      name="clear"
                      @click="handleDeleteAppointment(index, item.id)"
                    />
                  </van-col>
                </van-row>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="爱车保养" name="2">
          <!-- 预约时间 -->
          <div class="block">
            <div class="title">预约时间设置</div>
            <div class="content">
              <van-row class="appointment-item">
                <van-col span="11">时间段</van-col>
                <van-col span="11">可预约人数</van-col>
                <van-col span="2"></van-col>
              </van-row>
              <div v-for="(item, index) in appointmentList" :key="index">
                <van-row class="appointment-item" v-if="item.category == 2">
                  <van-col span="11" @click="handleEditTime(index)">
                    {{ item.startTime + "-" + item.endTime }}
                  </van-col>
                  <van-col span="11" @click="handleEditTime(index)">
                    {{ item.appointmentCount }}
                  </van-col>
                  <van-col span="2">
                    <van-icon
                      name="clear"
                      @click="handleDeleteAppointment(index, item.id)"
                    />
                  </van-col>
                </van-row>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="车辆维修" name="3">
          <!-- 预约时间 -->
          <div class="block">
            <div class="title">预约时间设置</div>
            <div class="content">
              <van-row class="appointment-item">
                <van-col span="11">时间段</van-col>
                <van-col span="11">可预约人数</van-col>
                <van-col span="2"></van-col>
              </van-row>
              <div v-for="(item, index) in appointmentList" :key="index">
                <van-row class="appointment-item" v-if="item.category == 3">
                  <van-col span="11" @click="handleEditTime(index)">
                    {{ item.startTime + "-" + item.endTime }}
                  </van-col>
                  <van-col span="11" @click="handleEditTime(index)">
                    {{ item.appointmentCount }}
                  </van-col>
                  <van-col span="2">
                    <van-icon
                      name="clear"
                      @click="handleDeleteAppointment(index, item.id)"
                    />
                  </van-col>
                </van-row>
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <!-- 提交 -->
    <div class="btn">
      <van-button type="info" @click="handleDefaultTime">使用模板</van-button>
      <van-button type="primary" @click="handleFormPopup">
        新增预约时间
      </van-button>
    </div>
    <!-- 新增预约时间弹框 -->
    <van-popup v-model="addAppointmentPopup" class="add-appointment-popup">
      <div class="title">新增预约时间</div>
      <div class="form">
        <van-form>
          <van-field
            readonly
            clickable
            name="picker"
            v-model="appointmentForm.startTime"
            label="开始时间"
            placeholder="点击选择开始时间"
            @click="handleTimeType(1)"
          />
          <van-field
            readonly
            clickable
            name="picker"
            v-model="appointmentForm.endTime"
            label="结束时间"
            placeholder="点击选择结束时间"
            @click="handleTimeType(2)"
          />
          <van-field
            v-model="appointmentForm.appointmentCount"
            type="number"
            name="密码"
            label="预约人数"
            placeholder="请输入可预约人数"
          />
          <div style="margin-top: 16px;">
            <van-button round block type="info" @click="handleAddAppointment">
              确定
            </van-button>
          </div>
        </van-form>
      </div>
    </van-popup>
    <!-- 时间选择器 -->
    <van-popup v-model="timePicker" position="bottom">
      <van-datetime-picker
        type="time"
        :min-hour="7"
        :max-hour="21"
        @confirm="handleTime"
        @cancel="timePicker = false"
      />
    </van-popup>
  </div>
</template>
<script>
import Navbar from "@/components/Navbar.vue";
import { Dialog } from "vant";
import {
  addAppointmentTime,
  deleteAppointmentTime,
  appointmentTimeList,
  editAppointmentTime,
  useTemplate
} from "@/api/appointment";
export default {
  components: {
    Navbar
  },
  data() {
    return {
      addAppointmentPopup: false,
      timePicker: false,
      timeType: 1,
      appointmentList: [],
      appointmentForm: {
        appointmentCount: "",
        category: 1,
        endTime: "",
        startTime: ""
      },
      formType: "add"
    };
  },
  mounted() {
    this.handleAppointmentTimeList();
  },
  methods: {
    // 获取预约时间段
    handleAppointmentTimeList() {
      appointmentTimeList().then(res => {
        // console.log("预约时间段 :>> ", res);
        res = this.ForwardRankingDate(res, "startTime");
        this.appointmentList = res;
      });
    },
    // 时间排序
    ForwardRankingDate(data, p) {
      for (let i = 0; i < data.length - 1; i++) {
        for (let j = 0; j < data.length - 1 - i; j++) {
          if (
            Date.parse("2008-08-08 " + data[j][p]) >
            Date.parse("2008-08-08 " + data[j + 1][p])
          ) {
            var temp = data[j];
            data[j] = data[j + 1];
            data[j + 1] = temp;
          }
        }
      }
      return data;
    },
    // 时间类型
    handleTimeType(type) {
      this.timeType = type;
      this.timePicker = true;
    },
    // 时间选择
    handleTime(time) {
      if (this.timeType === 1) {
        this.appointmentForm.startTime = time;
        this.appointmentList.forEach(val => {
          if (val.category == this.appointmentForm.category) {
            if (val.startTime === time) {
              this.$toast("开始时间有冲突,请修改");
              this.appointmentForm.startTime = "";
              return false;
            }
          }
        });
      } else {
        this.appointmentForm.endTime = time;
      }
      this.timePicker = false;
    },
    // 新增预约时间段
    handleFormPopup() {
      this.addAppointmentPopup = true;
      this.formType = "add";
    },
    // 提交表单
    handleAddAppointment() {
      if (!this.handleFormVerify()) {
        return false;
      }
      this.addAppointmentPopup = false;
      if (this.formType === "add") {
        this.appointmentForm.id = "";
        addAppointmentTime([this.appointmentForm]).then(res => {
          // console.log("新增预约时间段 :>> ", res);
          if (res.code === 0) {
            this.$toast("新增成功");
            this.handleAppointmentTimeList();
            this.handleCancel();
          }
        });
      } else {
        editAppointmentTime([this.appointmentForm]).then(res => {
          // console.log("修改预约时间段 :>> ", res);
          if (res.code === 0) {
            this.$toast("修改成功");
            this.handleAppointmentTimeList();
            this.handleCancel();
          }
        });
      }
    },
    // 删除预约时间段
    handleDeleteAppointment(index, id) {
      Dialog.confirm({
        title: "温馨提示",
        message: "确定删除该时间段吗?"
      }).then(() => {
        this.appointmentList.splice(index, 1);
        deleteAppointmentTime([id]).then(res => {
          // console.log("删除预约时间段 :>> ", res);
          if (res.code === 0) {
            this.$toast("删除成功");
            this.handleAppointmentTimeList();
          }
        });
      });
    },
    // 取消
    handleCancel() {
      this.appointmentForm.appointmentCount = "";
      this.appointmentForm.startTime = "";
      this.appointmentForm.endTime = "";
      this.addAppointmentPopup = false;
    },
    // 表单校验
    handleFormVerify() {
      if (this.appointmentForm.startTime.trim() === "") {
        this.$toast("请输入开始时间");
        return false;
      }
      if (this.appointmentForm.endTime.trim() === "") {
        this.$toast("请输入结束时间");
        return false;
      }
      if (this.appointmentForm.appointmentCount.trim() === "") {
        this.$toast("请输入可预约人数");
        return false;
      }
      return true;
    },
    // 设置模板
    handleDefaultTime() {
      Dialog.confirm({
        title: "温馨提示",
        message: "是否使用模板覆盖,此操作将会清除原有数据!"
      }).then(() => {
        useTemplate().then(res => {
          if (res.code === 0) {
            this.handleAppointmentTimeList();
            this.$toast("设置成功");
          }
        });
      });
    },
    // 修改设置
    handleEditTime(index) {
      this.addAppointmentPopup = true;
      let {
        startTime,
        endTime,
        appointmentCount,
        category,
        id
      } = this.appointmentList[index];
      this.appointmentForm = {
        appointmentCount: appointmentCount,
        category: category,
        endTime: endTime,
        startTime: startTime,
        id: id
      };
      this.formType = "edit";
    }
  }
};
</script>
<style lang="scss" scoped>
.appointment-setting {
  .tabbar {
    padding: 0 16px;

    .block {
      margin-bottom: 20px;

      .title {
        margin-bottom: 10px;
        text-align: left;
        font-size: 14px;
        color: #a1a1a1;
      }

      .content {
        padding: 0 16px;

        .appointment-item {
          padding: 5px 0;
          border-bottom: 1px solid #ccc;
        }

        .add {
          height: 30px;
          margin: 16px 0;
          border-radius: 5px;
        }
      }
    }
  }

  .btn {
    display: flex;
    justify-content: space-around;
  }

  .add-appointment-popup {
    width: 90%;
    padding: 20px 30px;
    box-sizing: border-box;

    .title {
      margin-bottom: 20px;
    }
  }
}
</style>
<style lang="scss">
.appointment-setting {
  .tabbar {
    .van-tabs {
      .van-tabs__wrap {
        margin-bottom: 20px;
      }

      .van-tab {
        margin-right: 10px;
        border-radius: 5px;
      }

      .van-tab:last-child {
        margin: 0;
      }

      .van-tabs__nav--card {
        margin: 0;
        border: none;
      }

      .van-tabs__nav--card .van-tab {
        border: 1px solid #0079fe;
      }

      .van-tabs__nav--card .van-tab.van-tab--active {
        background-color: #0079fe;
      }
    }

    .block {
      .content {
        .appointment-item {
          .van-icon {
            color: red;
          }
        }
      }
    }
  }

  .add-appointment-popup {
    .van-button--block {
      width: 50%;
      margin: 0 auto;
    }
  }
}
</style>
